"use client";

import { useState } from "react";
import Image from "next/image";
import { Check, ChevronDown } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { SetupPromptFallback, useSetupPromptCopy } from "@/components/copy-setup-prompt";
import { useHomeAppearance } from "@/components/home-appearance";
import { COPY_PROVIDERS } from "@/lib/marketing/setup-prompt";

export default function OtherSetupProviders() {
  const appearance = useHomeAppearance();
  const { state, copy, fallback } = useSetupPromptCopy();
  const [selected, setSelected] = useState("");
  return <>
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger className="conversion-provider-others" aria-label="Others">
        {state === "copied" ? <Check aria-hidden="true" /> : null}
        {state === "copied" ? "Copied" : "Others"}<ChevronDown aria-hidden="true" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" sideOffset={8} collisionPadding={12} className="conversion-site conversion-provider-menu" data-appearance={appearance} onCloseAutoFocus={event => { if (fallback.current) { event.preventDefault(); fallback.current.focus(); fallback.current.select(); } }}>
        <DropdownMenuLabel>Copy setup prompt for</DropdownMenuLabel>
        {COPY_PROVIDERS.map(provider => <DropdownMenuItem key={provider.id} disabled={state === "copying"} aria-label={`Copy setup prompt for ${provider.name}`} onSelect={() => { setSelected(provider.name); void copy(provider.id, provider); }}>
          <Image className={`conversion-provider-logo${provider.icon.endsWith("-color") ? " is-color" : ""}`} src={`/icons/providers/${provider.icon}.svg`} alt="" width={20} height={20} />
          <span>{provider.name}</span>
        </DropdownMenuItem>)}
      </DropdownMenuContent>
    </DropdownMenu>
    <span role="status" className="sr-only">{state === "copied" ? `Prompt copied for ${selected}.` : ""}</span>
    {state === "manual" ? <div className="conversion-provider-feedback"><SetupPromptFallback inputRef={fallback} /></div> : null}
  </>;
}
